import { objectOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isFreeTrialPilotDeepLinkQrCodeResult = objectOf({
  qr_code: string,
});
